import React, { Fragment } from "react";
import Countdown, { doubleDigit } from "react-downcount";
import ReactWOW from "react-wow";
// https://skyvow.github.io/react-wow/#/
// https://www.pexels.com/search/programming/

const endDate = new Date("March 27 2020 23:59:59");
// const endDate = "1569887999000";

const customRenderer = ({ days, hrs, mins, secs, isCompleted }) => {
  return isCompleted ? (
    ""
  ) : (
    <Fragment>
      <div className="segment">
        <span className="number">{days}</span>
        <span className="unit">days</span>
      </div>
      <div className="segment">
        <span className="number">{hrs}</span>
        <span className="unit">hours</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(mins)}</span>
        <span className="unit">min</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(secs)}</span>
        <span className="unit">sec</span>
      </div>
    </Fragment>
  );
};

class Hero extends React.Component {
  goRegister() {
    const target = document.getElementById("register");
    target.scrollIntoView({ block: "start", behavior: "smooth" });
  }
  render() {
    const msg = this.props.Message;
    return (
      <section
        id="hero"
        style={{ backgroundImage: "url(images/section-background-03.png)" }}
      >
        <div className="container">
          <img
            src="images/hero-image.png"
            alt="Best Coder Challenge logo"
            className="hero-image"
          />
          <div
            className="hero-circle"
            style={{
              backgroundImage: "url(images/hero-background-circle.png)"
            }}
          ></div>
          {/* <ReactWOW animation="bounceInLeft" delay="0.3s">
            <p className="date">28 March 2020</p>
          </ReactWOW> */}
          <a
            href="https://techatshopee.formstack.com/forms/thailand_data_challenge_2020"
            className="btn btn-primary"
          >
            {/* {msg.registerNow} */}
            Register Now
          </a>

          <ReactWOW animation="bounceInLeft" delay="0.4s">
            <p className="desc">
              The <strong style={{ fontWeight: "bold" }}>largest</strong> data
              analytics competition in Thailand
            </p>
          </ReactWOW>
          <ReactWOW animation="bounceInLeft" delay="0.5s">
            {/* <a href="https://bestcoderchallenge2019.formstack.com/forms/bestcoder2019" className="btn btn-primary" target="_blank" rel="noopener noreferrer">Register Now</a> */}
            {/* <Countdown className="countdown" endDate={endDate}>
              {customRenderer}
            </Countdown> */}
          </ReactWOW>
        </div>
      </section>
    );
  }
}

export default Hero;
